import React from "react";

export const Textarea = ({
  name,
  placeholder,
  value,
  onChange,
  onBlur,
  disabled = false,
  label,
  isInvalid = false,
  invalidMessage,
  height = "200px",
  width = "100%",
  fontSize = "14px",
  rows,
  className = "",
  resizable = false,
}) => {
  const heightValue = typeof height === 'number' ? `${height}px` : height;
  const widthValue = typeof width === 'number' ? `${width}px` : width;
  const fontSizeValue = typeof fontSize === 'number' ? `${fontSize}px` : fontSize;

  const textareaStyle = {
    height: heightValue,
    width: widthValue,
    fontSize: fontSizeValue,
    backgroundColor: '#ffffff',
    border: '1px solid #e8e8e8',
    borderRadius: '5px',
    padding: '15px',
    color: '#282828',
    fontFamily: "'Hanken Grotesk', sans-serif",
    outline: 'none',
    transition: 'border-color 0.2s',
    resize: resizable ? 'vertical' : 'none',
    lineHeight: '20px',
  };

  const labelStyle = {
    fontSize: '14px',
    color: '#282828',
    fontFamily: "'Hanken Grotesk', sans-serif",
    fontWeight: '400',
    lineHeight: '20px',
    marginBottom: '10px',
    display: 'block',
  };

  const containerStyle = {
    width: widthValue,
    marginBottom: '16px',
  };

  return (
    <div style={containerStyle} className={className}>
      {label && (
        <label style={labelStyle} htmlFor={name}>
          {label}
        </label>
      )}
      <textarea
        id={name}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        rows={rows}
        style={{
          ...textareaStyle,
          borderColor: isInvalid ? '#dc3545' : '#e8e8e8',
        }}
        onFocus={(e) => {
          e.target.style.borderColor = '#dbbe78';
        }}
        onBlurCapture={(e) => {
          if (!isInvalid) {
            e.target.style.borderColor = '#e8e8e8';
          }
        }}
      />
      {isInvalid && invalidMessage && (
        <p
          style={{
            color: '#dc3545',
            fontSize: '12px',
            marginTop: '5px',
            marginBottom: '0',
          }}
        >
          {invalidMessage}
        </p>
      )}
    </div>
  );
};
